import { rewardService, vipTierService } from "@/services";
import {SHARED_LOADING, SHARED_UNLOADING} from '@/store/shared.module'
import {SESSION, SHARED} from '@/constants/constants'
import router from '@/router'
import {ROUTE_NAME} from '@/constants/route.constants'
import { REWARD_GET_CHECK_IN_DAY } from "@/store/reward.module";

//define module name
const MODULE_NAME = 'vipTier/'

const A_GET_RECURRING_BONUS = 'getRecurringBonus'
const A_POST_RECURRING_BONUS = 'postRecurringBonus'

export const VIPTIER_GET_RECURRING_BONUS = MODULE_NAME + A_GET_RECURRING_BONUS
export const VIPTIER_POST_RECURRING_BONUS = MODULE_NAME + A_POST_RECURRING_BONUS

const M_SET_RECURRING_BONUS = 'setRecurringBonus'
const M_POST_RECURRING_BONUS = 'postRecurringBonus'

const state = {
  recurringBonus: [],
  recurringBonusResponse: []
}

//to retrieve data from store state (called by component)
const getters = {}

//to perform some actions related with updating state (called by component)
const actions = {
  [A_GET_RECURRING_BONUS]({dispatch, commit}) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    vipTierService.getRecurringBonus().then(
      data => {
        let result = data
        commit(M_SET_RECURRING_BONUS, { result })
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      },
      error => {
        let result = error
        commit(M_SET_RECURRING_BONUS, { result })
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      }
    )
  },
  [A_POST_RECURRING_BONUS]({dispatch, commit}, {obj}) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    vipTierService.postRecurringBonus(obj).then(
      data => {
        let result = data
        commit(M_POST_RECURRING_BONUS, { result })
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      },
      error => {
        let result = error
        commit(M_POST_RECURRING_BONUS, { result })
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      }
    )
  }
}

//to update state values (called by actions)
const mutations = {
  [M_SET_RECURRING_BONUS](state, { result }) {
    if (result.success) {
      state.recurringBonus = result.data
    }
  },
  [M_POST_RECURRING_BONUS](state, { result }) {
    state.recurringBonusResponse = result
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
